import { put, takeEvery } from 'redux-saga/effects';

import { verifyAddressRequest } from '../../../api/Carrier/verifyAddressCommand';
import { executeSagaRequest } from '../../../services';

import { VERIFY_ADDRESS } from './actionTypes';

function* verifyAddressWorker({ payload }: any) {
  yield executeSagaRequest(
    VERIFY_ADDRESS,
    verifyAddressRequest({
      carrierCompany: payload.carrierCompany,
      address: payload.address,
    }),
  );
  yield put(VERIFY_ADDRESS.end());
}

export function* verifyAddressWatcher() {
  yield takeEvery(VERIFY_ADDRESS.BASE, verifyAddressWorker);
}
